import React from 'react'
import "../choose_us/ChooseUs.css"
import ReusableChooseUs from '../organic1-reusable/ReusableChooseUs'
import { Container, Row } from 'react-bootstrap'
const ChooseUs = () => {
  return (
    <>
    <section id="choose_us">
      <Container>
        <h1>Why Choose Us</h1>
        <Row>
          <ReusableChooseUs img="imeges/desktop1/Choose Us-camira.png"/>
          <ReusableChooseUs img="imeges/desktop1/Choose Us- appal.png"/>
          <ReusableChooseUs img="imeges/desktop1/Choose Us-camira.png"/>
        </Row>
      </Container>
  </section>
    </>
  )
}

export default ChooseUs